import { j as C } from "../../_virtual/jsx-runtime.js";
const i = ({
  width: o = 20,
  height: t = 20,
  viewBox: n = "0 0 20 20",
  fill: r = "currentColor",
  ...s
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: o,
    height: t,
    viewBox: n,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M6.66668 2.5V4.16667H5.00001V7.5C5.00001 9.34092 6.49239 10.8333 8.33334 10.8333C10.1743 10.8333 11.6667 9.34092 11.6667 7.5V4.16667H10V2.5H12.5C12.9603 2.5 13.3333 2.8731 13.3333 3.33333V7.5C13.3333 9.97725 11.5318 12.0338 9.16734 12.4308L9.16668 13.75C9.16668 15.3608 10.4725 16.6667 12.0833 16.6667C13.3311 16.6667 14.3958 15.8832 14.8124 14.7813C13.9403 14.3917 13.3333 13.5168 13.3333 12.5C13.3333 11.1193 14.4526 10 15.8333 10C17.2141 10 18.3333 11.1193 18.3333 12.5C18.3333 13.6426 17.5668 14.6062 16.52 14.9045C16.0085 16.8767 14.216 18.3333 12.0833 18.3333C9.55201 18.3333 7.50001 16.2813 7.50001 13.75L7.50017 12.4309C5.13533 12.0343 3.33334 9.97758 3.33334 7.5V3.33333C3.33334 2.8731 3.70644 2.5 4.16668 2.5H6.66668ZM15.8333 11.6667C15.3731 11.6667 15 12.0398 15 12.5C15 12.9603 15.3731 13.3333 15.8333 13.3333C16.2936 13.3333 16.6667 12.9603 16.6667 12.5C16.6667 12.0398 16.2936 11.6667 15.8333 11.6667Z",
        fill: r
      }
    )
  }
);
export {
  i as default
};
